import { MijnRoute } from '../mijn-navigatie.model';

export const CONTACT_TELEFONIE: MijnRoute = {
    path: 'contact-telefonie',
    navigationEvent: 'toContactTelefonie',
    regex: /^\/contact\/contact-telefonie$/,
    webcomponent: 'mijn-contact-telefonie-wrapper'
};
